export default "/_next/static/images/4bf88b576182777fe9d407ebb2ffa4f4.jpg";